/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCustomer = /* GraphQL */ `
  query GetCustomer($customer_code: String!) {
    getCustomer(customer_code: $customer_code) {
      code
      data {
        address
        country
        customer_code
        customer_id
        domain
        email
        name
        phone_number
        status
      }
      message
    }
  }
`;
export const getCustomerMX = /* GraphQL */ `
  query GetCustomerMX($customer_code: String!) {
    getCustomerMX(customer_code: $customer_code) {
      code
      data {
        address
        country
        customer_code
        customer_id
        domain
        email
        name
        phone_number
        status
      }
      message
    }
  }
`;
export const getCustomerPE = /* GraphQL */ `
  query GetCustomerPE($customer_code: String!) {
    getCustomerPE(customer_code: $customer_code) {
      code
      data {
        customer_code
        customer_id
        name
        status
      }
      message
    }
  }
`;
export const getCustomerProducts = /* GraphQL */ `
  query GetCustomerProducts($customer_code: String!, $product_id: String) {
    getCustomerProducts(
      customer_code: $customer_code
      product_id: $product_id
    ) {
      code
      data {
        products {
          code
          description {
            en
            es
          }
          enabled
          name
          status
          type
        }
      }
      message
    }
  }
`;
export const getGroupsList = /* GraphQL */ `
  query GetGroupsList($customer_code: String!, $input: GetGroupsInput!) {
    getGroupsList(customer_code: $customer_code, input: $input) {
      code
      data {
        from
        items {
          description
          group_id
          name
          users
        }
        size
        total
      }
      message
    }
  }
`;
export const getLoggedUser = /* GraphQL */ `
  query GetLoggedUser($customer_code: String!) {
    getLoggedUser(customer_code: $customer_code) {
      code
      data {
        accounts {
          account_code
          account_id
          account_name
          country
          entity_id
          father_account
        }
        active
        address
        assigned_ruts
        cognito_signup
        country
        created
        email
        entity_id
        family_name
        given_name
        groups
        last_login_date
        pending
        phone_number
        position
        updated
        user_id
        user_name
      }
      message
    }
  }
`;
export const getUserSettings = /* GraphQL */ `
  query GetUserSettings($email: String!) {
    getUserSettings(email: $email) {
      code
      data {
        email
        language
        searcher
        subscriptions
      }
      message
    }
  }
`;
export const getUsersList = /* GraphQL */ `
  query GetUsersList(
    $customer_code: String!
    $from: Int!
    $group_filter: GetUsersByGroupFilter
    $size: Int!
    $status: String
    $word_filter: String
  ) {
    getUsersList(
      customer_code: $customer_code
      from: $from
      group_filter: $group_filter
      size: $size
      status: $status
      word_filter: $word_filter
    ) {
      code
      data {
        from
        items {
          active
          address
          assigned_ruts
          cognito_signup
          country
          created
          customer_code
          customer_id
          email
          entity_id
          family_name
          given_name
          groups {
            group_id
            group_name
          }
          last_login_date
          pending
          phone_number
          position
          updated
          user_id
          user_name
        }
        size
        total
      }
      message
    }
  }
`;
export const searchEnterprises = /* GraphQL */ `
  query SearchEnterprises(
    $customer_code: String!
    $filter: String
    $from: Int!
    $match_enterprices: [String]
    $not_match_enterprices: [String]
    $size: Int!
  ) {
    searchEnterprises(
      customer_code: $customer_code
      filter: $filter
      from: $from
      match_enterprices: $match_enterprices
      not_match_enterprices: $not_match_enterprices
      size: $size
    ) {
      code
      data {
        from
        items {
          subscriber_id
          subscriber_name
        }
        size
        total
      }
      message
    }
  }
`;
export const searchEnterprisesPE = /* GraphQL */ `
  query SearchEnterprisesPE(
    $customer_code: String!
    $filter: String
    $from: Int!
    $match_enterprices: [String]
    $not_match_enterprices: [String]
    $size: Int!
  ) {
    searchEnterprisesPE(
      customer_code: $customer_code
      filter: $filter
      from: $from
      match_enterprices: $match_enterprices
      not_match_enterprices: $not_match_enterprices
      size: $size
    ) {
      code
      data {
        from
        items {
          subscriber_id
          subscriber_name
        }
        size
        total
      }
      message
    }
  }
`;
export const searchUserSubscribers = /* GraphQL */ `
  query SearchUserSubscribers($customer_code: String, $subscribers: [String]) {
    searchUserSubscribers(
      customer_code: $customer_code
      subscribers: $subscribers
    ) {
      code
      data {
        items {
          subscriber_id
          users
        }
      }
      message
    }
  }
`;
